"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepMerge = void 0;
const tslib_1 = require("tslib");
const array_helper_1 = require("./array.helper");
const get_1 = tslib_1.__importDefault(require("lodash/get"));
const cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
const isFunction_1 = tslib_1.__importDefault(require("lodash/isFunction"));
function deepMerge(arr1, arr2, options, method) {
    const match = (0, array_helper_1.extractMatch)(options);
    const clone = (0, get_1.default)(options, 'clone', true);
    const mMethod = (0, get_1.default)(options, 'method', method || 'push');
    return arr2.reduce((items, arr2Item) => {
        const index = items.findIndex((item) => {
            if ((0, isFunction_1.default)(match))
                return match(item, arr2Item);
            return (0, get_1.default)(item, match) === (0, get_1.default)(arr2Item, match);
        });
        index === -1
            ? items[mMethod](arr2Item)
            : items.splice(index, 1, arr2Item);
        return items;
    }, clone ? (0, cloneDeep_1.default)(arr1) : arr1);
}
exports.deepMerge = deepMerge;
